export function resetDeepPlanApprovalForTurn(
  sessionId: string | null | undefined,
  setPlanApproved: unknown
): void {
  if (sessionId && typeof setPlanApproved === "function") {
    setPlanApproved(sessionId, false)
  }
}
